import React, { useState } from "react";
import BLInput from "../../../utils/components/BLInput";
import BLDropdown from "../../../utils/components/BLDropdown";
import BLLoader from "../../../utils/components/BLLoader";
import { currencyFormatter } from "../../../utils/helper";
import dayjs from "dayjs";

const ApplyGiftCard = (props) => {
  const [giftCardId, setGiftCardId] = useState("");
  const [newGiftCard, setNewGiftCard] = useState("");

  const unusedGiftCards = props.giftCards.filter((data) => !data.isUsed);

  const gcOptions = unusedGiftCards.map((data) => {
    return {
      name: `${currencyFormatter(
        data.currency,
        data.amount
      )} - ${props.translate("global.exp")}: ${dayjs(data.expiry).format(
        "DD/MM/YYYY HH:mm"
      )}`,
      value: data.id,
    };
  });

  const handleApplyGiftCard = () => {
    if (
      (giftCardId === "other" && newGiftCard) ||
      (giftCardId !== "other" && giftCardId)
    ) {
      if (props.handleApplyGiftCard(giftCardId, newGiftCard)) {
        setGiftCardId("");
      }
    }
  };

  return (
    <div className="single-gift-card">
      <div className="row">
        <div className="col-12 col-md-6">
          {giftCardId === "other" ? (
            <>
              <BLInput
                label={props.translate("payment.use_a_gift_card.card_number")}
                type="text"
                name="otherGiftCard"
                value={newGiftCard}
                changed={(e) => setNewGiftCard(e.target.value)}
              />
              <button
                className="cancel-button position-absolute"
                onClick={() => {
                  setGiftCardId("");
                  setNewGiftCard("");
                }}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.96 0C3.12748 0 0 3.01964 0 6.72C0 10.4204 3.12748 13.44 6.96 13.44C10.7925 13.44 13.92 10.4204 13.92 6.72C13.92 3.01964 10.7925 0 6.96 0Z"
                    fill="#8E8E8E"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.82344 4.16719C9.66598 4.00973 9.41069 4.00973 9.25323 4.16719L7 6.42041L4.74677 4.16719C4.58931 4.00973 4.33402 4.00973 4.17656 4.16719L4.16658 4.17717C4.00912 4.33463 4.00912 4.58992 4.16658 4.74738L6.41981 7.0006L4.16658 9.25383C4.00912 9.41129 4.00912 9.66658 4.16658 9.82404L4.17656 9.83402C4.33402 9.99148 4.58931 9.99148 4.74677 9.83402L7 7.58079L9.25323 9.83402C9.41069 9.99148 9.66598 9.99148 9.82344 9.83402L9.83342 9.82404C9.99088 9.66658 9.99088 9.41129 9.83342 9.25383L7.58019 7.0006L9.83342 4.74738C9.99088 4.58992 9.99088 4.33463 9.83342 4.17717L9.82344 4.16719Z"
                    fill="white"
                  />
                  <path
                    d="M9.82344 4.16719L9.64666 4.34396L9.82344 4.16719ZM7 6.42041L6.82322 6.59719L7 6.77397L7.17678 6.59719L7 6.42041ZM4.74677 4.16719L4.57 4.34396L4.74677 4.16719ZM6.41981 7.0006L6.59659 7.17738L6.77336 7.0006L6.59659 6.82383L6.41981 7.0006ZM4.16658 9.82404L3.98981 10.0008L4.16658 9.82404ZM4.17656 9.83402L4.35334 9.65724L4.17656 9.83402ZM7 7.58079L7.17678 7.40402L7 7.22724L6.82322 7.40402L7 7.58079ZM7.58019 7.0006L7.40341 6.82383L7.22664 7.0006L7.40341 7.17738L7.58019 7.0006ZM9.83342 4.17717L10.0102 4.00039L9.83342 4.17717ZM9.43 4.34396C9.48983 4.28414 9.58683 4.28414 9.64666 4.34396L10.0002 3.99041C9.74512 3.73532 9.33154 3.73532 9.07645 3.99041L9.43 4.34396ZM7.17678 6.59719L9.43 4.34396L9.07645 3.99041L6.82322 6.24364L7.17678 6.59719ZM4.57 4.34396L6.82322 6.59719L7.17678 6.24364L4.92355 3.99041L4.57 4.34396ZM4.35334 4.34396C4.41317 4.28414 4.51017 4.28414 4.57 4.34396L4.92355 3.99041C4.66846 3.73532 4.25488 3.73532 3.99979 3.99041L4.35334 4.34396ZM4.34336 4.35394L4.35334 4.34396L3.99979 3.99041L3.98981 4.00039L4.34336 4.35394ZM4.34336 4.5706C4.28353 4.51077 4.28353 4.41377 4.34336 4.35394L3.98981 4.00039C3.73472 4.25548 3.73472 4.66906 3.98981 4.92415L4.34336 4.5706ZM6.59659 6.82383L4.34336 4.5706L3.98981 4.92415L6.24303 7.17738L6.59659 6.82383ZM4.34336 9.43061L6.59659 7.17738L6.24303 6.82383L3.98981 9.07705L4.34336 9.43061ZM4.34336 9.64726C4.28353 9.58744 4.28353 9.49044 4.34336 9.43061L3.98981 9.07705C3.73472 9.33214 3.73472 9.74573 3.98981 10.0008L4.34336 9.64726ZM4.35334 9.65724L4.34336 9.64726L3.98981 10.0008L3.99979 10.0108L4.35334 9.65724ZM4.57 9.65724C4.51017 9.71707 4.41317 9.71707 4.35334 9.65724L3.99979 10.0108C4.25488 10.2659 4.66846 10.2659 4.92355 10.0108L4.57 9.65724ZM6.82322 7.40402L4.57 9.65724L4.92355 10.0108L7.17678 7.75757L6.82322 7.40402ZM9.43 9.65724L7.17678 7.40402L6.82322 7.75757L9.07645 10.0108L9.43 9.65724ZM9.64666 9.65724C9.58683 9.71707 9.48983 9.71707 9.43 9.65724L9.07645 10.0108C9.33154 10.2659 9.74512 10.2659 10.0002 10.0108L9.64666 9.65724ZM9.65664 9.64726L9.64666 9.65724L10.0002 10.0108L10.0102 10.0008L9.65664 9.64726ZM9.65664 9.43061C9.71647 9.49044 9.71647 9.58744 9.65664 9.64726L10.0102 10.0008C10.2653 9.74573 10.2653 9.33214 10.0102 9.07705L9.65664 9.43061ZM7.40341 7.17738L9.65664 9.43061L10.0102 9.07705L7.75697 6.82383L7.40341 7.17738ZM9.65664 4.5706L7.40341 6.82383L7.75697 7.17738L10.0102 4.92415L9.65664 4.5706ZM9.65664 4.35394C9.71647 4.41377 9.71647 4.51077 9.65664 4.5706L10.0102 4.92415C10.2653 4.66906 10.2653 4.25548 10.0102 4.00039L9.65664 4.35394ZM9.64666 4.34396L9.65664 4.35394L10.0102 4.00039L10.0002 3.99041L9.64666 4.34396Z"
                    fill="white"
                  />
                </svg>
              </button>
            </>
          ) : (
            <BLDropdown
              name="gift-card"
              placeholder={props.translate(
                "payment.use_a_gift_card.pick_a_gift_card"
              )}
              options={[
                ...gcOptions,
                {
                  name: props.translate(
                    "payment.use_a_gift_card.use_another_gift_card"
                  ),
                  value: "other",
                },
              ]}
              default={giftCardId}
              setValue={(value) => setGiftCardId(value)}
            />
          )}
        </div>
        <div className="col-12 col-md-6 d-flex align-items-center">
          {props.isApplyingGiftCard ? (
            <BLLoader />
          ) : (
            <button className="apply-button" onClick={handleApplyGiftCard}>
              {props.translate("global.apply")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApplyGiftCard;
